import {Component, DestroyRef, Inject, inject, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {Subject, takeUntil} from 'rxjs';
import {
  MatCell, MatCellDef, MatColumnDef,
  MatHeaderCell, MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef,
  MatTable,
  MatTableDataSource
} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort, MatSortHeader} from '@angular/material/sort';
import {Router} from '@angular/router';
import {
  CurrentAdgroupSelectService,
  CurrentCampaignSelectService,
  CurrentCrudSelectBehaviorServiceAsString,
  CurrentSelectedSlugBehaviorService,
  SnackBarService
} from '../objectPassingService';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {GetAllCampaignPayloadModel} from './campaign_interfaces';
import {CampaignService} from './campaigns_service';
import {MatProgressBar, MatProgressBarModule} from '@angular/material/progress-bar';
import { NgClass } from '@angular/common';
import {MatList, MatListItem, MatListModule} from '@angular/material/list';
import {MatDivider, MatDividerModule} from '@angular/material/divider';
import {MatIcon} from '@angular/material/icon';
import {MatTooltip} from '@angular/material/tooltip';
import {MatButtonModule, MatFabButton, MatIconButton} from '@angular/material/button';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatInput, MatInputModule} from '@angular/material/input';
import {MatCard, MatCardModule} from '@angular/material/card';
import {MatToolbarModule} from '@angular/material/toolbar';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';

export interface CreateCampaignInitPayload {
  is_edit: false;
}


@Component({
  selector: 'app-campaigns',
  imports: [
    MatProgressBar,
    MatList,
    MatListItem,
    MatDivider,
    MatIcon,
    MatTooltip,
    MatFabButton,
    MatLabel,
    MatFormField,
    MatInput,
    MatTable,
    MatCard,
    MatHeaderCell,
    MatCell,
    MatSort,
    MatColumnDef,
    MatIconButton,
    MatPaginator,
    MatHeaderCellDef,
    MatCellDef,
    MatHeaderRow,
    MatRow,
    MatRowDef,
    MatHeaderRowDef,
    MatSortHeader,
    NgClass
],
  templateUrl: './campaigns.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './campaigns.component.css'
})
export class CampaignsComponent implements OnInit , OnDestroy{

  private destroyRef = inject(DestroyRef);
  destroyed = new Subject<void>();
  client_id: number = 0
  client_slug: string = '';
  campaign_group_sequence_id: string = '';
  campaign_group_id: string = '';
  is_loading = true;

  dataSource!: MatTableDataSource<GetAllCampaignPayloadModel>;
  displayedColumns: string[] = ['campaign_id','name', 'status', 'View', 'Edit', 'Delete'];


  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;

  constructor(
    public router: Router, //all components need this
    private currentSelectedSlugBehaviorService: CurrentSelectedSlugBehaviorService,
    public dialog: MatDialog,
    private currentCrudSelectBehaviorServiceAsString: CurrentCrudSelectBehaviorServiceAsString,
    private campaignService: CampaignService,
    private currentCampaignSelectService: CurrentCampaignSelectService,
    private currentAdgroupSelectService: CurrentAdgroupSelectService,
  ) { } //end constructor

  ngOnInit(): void {

    localStorage.removeItem('campaign_id');
    localStorage.removeItem('adgroup_id');
    localStorage.removeItem('ad_id');


    this.currentCampaignSelectService.announceCampaignSelect('')
    this.currentAdgroupSelectService.announceAdgroupSelect('')

    this.client_id = parseInt(localStorage.getItem('client_id') || '0');
    this.client_slug = localStorage.getItem('client_slug') || '';
    this.campaign_group_id = localStorage.getItem('campaign_group_id') || '';
    localStorage.removeItem('campaign_id');

    console.log('####################################################')
    console.log('client_id', this.client_id)
    console.log('client_slug', this.client_slug)
    console.log('campaign_group_id', this.campaign_group_id)

    if (this.campaign_group_id) {
      this.getData(false)
    } else {
      this.is_loading = false;
    }

  } //end ngOnInit

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }

  getData(is_mocked:boolean = false) {

    this.is_loading = true;
    const show_deleted = 'false'

    let client_id = 1;
    this.campaignService.gets(`adserver/campaigns/${this.campaign_group_id}`, is_mocked).pipe(takeUntil(this.destroyed)).subscribe( (data: any) => {
      console.log(data);
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.is_loading = false;
      }, (error) => {
        console.log('error', error);
        this.is_loading = false;
      }, () => {
        console.log('complete');
      }
    ) //end subscribe
  } //end getData

  addCampaign(is_edit: boolean, row?: GetAllCampaignPayloadModel): void {

    localStorage.removeItem('campaignsaved');
    localStorage.removeItem('adgroupsaved');
    localStorage.removeItem('adsaved');
    if (is_edit && row) {
      this.currentCrudSelectBehaviorServiceAsString.announce(JSON.stringify(row));
      localStorage.setItem('campaign_id', row.campaign_id);
    } else {
      const payload: CreateCampaignInitPayload = { is_edit: false };
      this.currentCrudSelectBehaviorServiceAsString.announce(JSON.stringify(payload));
    }
    // Ensure subscribers are ready before navigation
    // It’s faster and cleaner than setTimeout(..., 0).
    queueMicrotask(() => {
      this.router.navigate(
        ['/nav-campaigns', { outlets: { admeta: ['campaigns-meta'] } }]
      ).then(() => console.log('Redirected to campaigns-met'));
    });
  }

  getTableRecord(row: object) {
  } // end getTableRecord

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  } //end applyFilter

  deleteRow(row: GetAllCampaignPayloadModel){

    let campaign_id = row.campaign_id;
    this.campaignService.delete(`adserver/campaign/${campaign_id}`).pipe(takeUntil(this.destroyed)).subscribe(x => {
        console.log(x);
        this.getData(false);
    }, error => {
      console.log('error',error)
    });

    console.log('deleteRow', row);
  } //end deleteRow

  viewData(row: GetAllCampaignPayloadModel) {
    console.log('viewData', row);
    const campaign_id = row.campaign_id
    //this.currentCampaignSelectService.announceCampaignGroupSelect(campaign_group_id);
    localStorage.setItem('campaign_id', campaign_id);
    localStorage.removeItem('adgroup_id');
    localStorage.removeItem('ad_id');


    localStorage.removeItem('adgroup_name');
    this.currentAdgroupSelectService.announceAdgroupSelect('');
    localStorage.setItem('campaign_name', row.name);
    this.currentCampaignSelectService.announceCampaignSelect(row.name);
    this.router.navigate(['/nav-campaigns',  { outlets: { admeta: ['adgroups'] } }]).then(r => console.log('redirect to adgroups'));
  } //end viewData(row)


} //end CampaignsComponent


